module.exports = __webpack_public_path__ + "fonts/B+sfKY7L.woff2";